import { connect } from 'react-redux';

import {
  checkDailyQuizStatus,
  setDailyQuiz,
} from '../actions/dailyQuizActions';
import { openPdfViewer } from '../actions/dashboardActions';
import { activateSubscription } from '../actions/manageSubscriptionActions';
import { getPdfByReference, setQuestion } from '../actions/studyMainActions';
import { getUserSubscription } from '../components/AccountSettings/AccountSettingsSelectors';
import Daily20QuizReview from '../components/Daily20Quiz/Daily20QuizReview.jsx';
import { getQuiz } from '../components/Daily20Quiz/daily20QuizSelectors';
import { getShowPdfViewer } from '../components/Dashboard/dashboardSelectors';
import {
  getSubscriptionActivationMessage,
  getSubscriptionActivationSuccess,
  getSubscriptionActivationWaiting,
} from '../components/ManageSubscription/ManageSubscriptionSelectors';
import { getPdfLink } from '../components/Study/studyMainSelectors'; // SELECTORS
import { verifyLoggedUser } from '../utils/verifyUserLogged';

const mapStateToProps = (state) => ({
  quiz: getQuiz(state),
  userSubscription: getUserSubscription(state),
  subscriptionActivationMessage: getSubscriptionActivationMessage(state),
  subscriptionActivationWaiting: getSubscriptionActivationWaiting(state),
  subscriptionActivationSucces: getSubscriptionActivationSuccess(state),
  pdfLink: getPdfLink(state),
  showPdfViewer: getShowPdfViewer(state),
});

const mapDispatchToProps = (dispatch) => ({
  setDailyQuiz: (quiz) => dispatch(setDailyQuiz(quiz)),
  checkDailyQuizStatus: () => dispatch(checkDailyQuizStatus()),
  verifyLoggedUser: () => verifyLoggedUser(),
  openPdfViewer: (value) => dispatch(openPdfViewer(value)),
  setQuestion: (question, questionData = []) =>
    dispatch(setQuestion(question, questionData)),
  activateSubscription: () => {
    dispatch(activateSubscription());
  },
  getPdfByReference: (payload) => dispatch(getPdfByReference(payload)),
});

const Daily20QuizContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Daily20QuizReview);

export default Daily20QuizContainer;
